// cSpell:ignore Afgerekend facturen huurder Huurder Kosten Totaal voor
// The Info tab's "Kosten" totals of a confirmed settlement with one lease
// (M23, retest of 2026-10-20). They add up the whole invoices; the tenant's
// provisions and balance follow when the tenant carries exactly those
// invoices. A final settlement on departure in a building settles only the
// tenant's part of each invoice: the total then names the invoices, and
// "Afgerekend voor <huurder>" with the tenant's part leads to the provisions
// and the balance, so the lines add up. Any other settlement whose tenant
// carries a part stops at the invoices, as before.

import { toCents } from "../../../../money.utils";

interface ITotalLine {
  id: string;
  label: string;
  amount?: number;
}

export const oneLeaseInfoTotals = <Line extends ITotalLine>(params: {
  // The invoices' totals, their "costs" line (incl. VAT) last.
  invoiceLines: Line[];
  // The tenant's costs incl. VAT (tenantCardCosts).
  tenantCosts: number;
  // The tenant's provisions and balance (tenantClosingTotals).
  closing: Line[];
  isDeparture: boolean;
  // "Totaal facturen incl. btw".
  invoicesLabel: string;
  // "Afgerekend voor Hugo Huurder".
  settledForLabel: string;
}): Line[] => {
  const {
    invoiceLines,
    tenantCosts,
    closing,
    isDeparture,
    invoicesLabel,
    settledForLabel,
  } = params;
  const invoices = invoiceLines.find(line => line.id === "costs");
  if (!invoices || toCents(tenantCosts) === toCents(invoices.amount ?? 0)) {
    return [...invoiceLines, ...closing];
  }
  if (!isDeparture) return invoiceLines;
  return [
    ...invoiceLines.map(line =>
      line.id === "costs" ? { ...line, label: invoicesLabel } : line,
    ),
    {
      ...invoices,
      id: "tenant-costs",
      label: settledForLabel,
      info: undefined,
      amount: tenantCosts,
    },
    ...closing,
  ];
};
